import React, { forwardRef, useEffect, useState } from 'react'
import { Box, FormControlLabel, Grid, Radio, RadioGroup, Stack, Backdrop, CardContent, Card, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import ButtonComponent from '../../../../components/Buttons/ButtonComponent';

import { useFormik } from 'formik';
import ApiService from '../../../../services/ApiService';

import LoadingSpinner from '../../../../components/Components/LoadingSpinner';
import HeaderInfo from '../../../../components/Components/HeaderInfo';
import CustomToastContainer, { CustomDatePicker, Input } from '../../../../components/ui';
import { encryptFunction, PrintCSV } from '../../../../utils/reusableFunction';

const ExportEFakturView = forwardRef(() => {
  const history = useNavigate()

  const date = new Date()
  const dateString = date.toLocaleDateString("sv-se").split('T')[0]

  const [isLoading, setIsLoading] = useState(true)

  const [remainingFaktur, setRemainingFaktur] = useState(0)
  const [dataRegUserAccess, setDataRegUserAccess] = useState([]);

  const BreadcrumbsItems = [
    { label: 'Majura', link: '/Majura', style: '' },
    { label: 'Export E-Faktur', link: '/Majura/ExportEFaktur', style: { color: '#0087C2', fontWeight: '700' } },
  ];

  useEffect(() => {
    document.title = 'Export E-Faktur - ' + JSON.parse(localStorage.getItem('branchName'));

    getDataAccess()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const inputNumberValidation = (name, e) => {
    const regex = /^[0-9\b]+$/
    const value = e.target.value

    if (value === '' || regex.test(value)) {
      formik.setFieldValue(name, value)
    }
  }

  const getDataAccess = () => {
    setIsLoading(true)
    let params = [];
    let pId = 0;
    let listMenu = JSON.parse(localStorage.getItem("dataMenuCode")) || [];
    let hasAccess = false

    const indexMenu = listMenu.findIndex((elm) => elm.code === 'REXPFAK')
    if (indexMenu !== -1) {
      pId = listMenu[indexMenu].id
      hasAccess = true
    }

    if (hasAccess) {
      params = [
        ...params,
        { attr: "permissionId", value: "" + pId },
        { attr: "userId", value: "" + JSON.parse(localStorage.getItem("userId")) },
        { attr: "roleId", value: "" + JSON.parse(localStorage.getItem("roleId")) }
      ];

      ApiService.IdentityPostByPage('regUserAccess/regUserAccess', "PAGE", 1, 100, params, [])
        .then((response) => {
          if (response.data.code === 200) {
            setDataRegUserAccess(response.data.data.userAccess);

            getFakturData()
          }
        })
        .catch(function (error) {
          console.error("error saat fetch", error);
          history('/Majura');
        });
    } else {
      history('/Majura');
    }
  };

  const getFakturData = () => {
    // TODO Get remaining faktur from BE
    setIsLoading(true)
    try {
      setRemainingFaktur(0)
    } catch (error) {
      console.log(error)
    }
    setIsLoading(false)
  }

  const handlePrint = () => {
    setIsLoading(true);

    let params = [];
    let payload = formik.values;

    params = [
      ...params,
      {
        "attr": "FilterBy",
        "value": '' + payload.filterBy
      }
    ]

    if (parseInt(payload.filterBy) > 0) {
      if (parseInt(payload.filterBy) > 1) {
        params = [
          ...params,
          {
            "attr": "StartInvoice",
            "value": '' + payload.startInvoice
          },
          {
            "attr": "EndInvoice",
            "value": '' + payload.endInvoice
          }
        ]
      }
      else {
        params = [
          ...params,
          {
            "attr": "StartDate",
            "value": '' + payload.startDate
          },
          {
            "attr": "EndDate",
            "value": '' + payload.endDate
          },
        ]
      }
    }

    let reportLink = 'Reports/Finance/Print/EFaktur/ExportEFakturReport/ExportEFakturReport/PrintExportEFaktur?payloads=' + encryptFunction(params);
    PrintCSV(setIsLoading, 'Export E-Faktur', reportLink);
  }

  const setDefault = () => {
    formik.setFieldValue('startDate', dateString)
    formik.setFieldValue('endDate', dateString)
    formik.setFieldValue('startInvoice', 0)
    formik.setFieldValue('endInvoice', 0)
  }

  const formik = useFormik({
    initialValues: {
      filterBy: '0',
      startDate: dateString,
      endDate: dateString,
      startInvoice: 0,
      endInvoice: 0,
    },
    validationSchema: undefined,
  })

  const ButtonComponents = () => {
    return (
      <div className="row" spacing={'12px'}>
        <div className='col-12' spacing={'12px'}>
          <Grid container item spacing={'12px'} direction="row" style={{ 'maxWidth': '100vw', margin: '0px', columnGap: '8px', rowGap: '10px' }}>
            {dataRegUserAccess.map((elm, index) => (
              <React.Fragment key={index}>
                {elm.accessCode === 'PRI' && ButtonComponent.ExcelButton(() => handlePrint(), 'Print CSV')}
              </React.Fragment>
            ))}
          </Grid>
        </div>
      </div>
    )
  }

  return (
    <>
      <Box className='w-100' sx={{ width: '100%', p: 3 }}>
        <CustomToastContainer />
        <Grid container spacing={0} direction="column">
          <HeaderInfo
            title={'Export E-Faktur'}
            isJobType={false}
            BreadcrumbsItems={BreadcrumbsItems}
            ButtonComponents={ButtonComponents}
          />

          <Grid item xs={12} style={{ 'width': '100%', 'borderRadius': '5px' }}>
            <div style={{ marginTop: '24px' }}>
              <Grid
                container
                spacing={'32px'}
                alignContent={'center'}
                justifyContent={'center'}
              >
                <Grid
                  item
                  xl={6}
                  lg={6}
                  sm={6}
                  xs={12}
                >
                  <Card component="div" style={{ borderRadius: '12px', backgroundColor: '#F2F2F2', padding: '16px 24px' }}>
                    <CardContent>
                      <div fullWidth>
                        <Typography
                          sx={{
                            color: 'var(--Primary-One, #083A50)',
                            fontFamily: 'Nunito',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: '600',
                            lineHeight: '19.6px',
                          }}
                        >
                          Filter
                        </Typography>

                        <RadioGroup
                          sx={{
                            width: '100%',
                          }}
                          fullWidth
                          aria-labelledby="variant-option"
                          name="variant"
                          value={formik.values.filterBy}
                          onChange={(e) => {
                            formik.setFieldValue('filterBy', e.target.value)
                            setDefault()
                          }}
                        >
                          <FormControlLabel
                            sx={{
                              color: 'var(--Blue-Primary-1, #083A50)',
                              fontFamily: 'Nunito',
                              fontSize: '12px !important',
                              fontStyle: 'normal',
                              fontWeight: '400',
                              lineHeight: '20px',
                            }}
                            value='0'
                            control={<Radio size='small' />}
                            label={
                              <Typography
                                sx={{
                                  color: 'var(--Blue-Primary-1, #083A50)',
                                  fontFamily: 'Nunito',
                                  fontSize: '12px !important',
                                  fontStyle: 'normal',
                                  fontWeight: '500',
                                  lineHeight: '20px',
                                }}
                              >
                                All
                              </Typography>
                            }
                          />

                          <FormControlLabel
                            sx={{
                              color: 'var(--Blue-Primary-1, #083A50)',
                              fontFamily: 'Nunito',
                              fontSize: '12px !important',
                              fontStyle: 'normal',
                              fontWeight: '400',
                              lineHeight: '20px',
                            }}
                            value='1'
                            control={<Radio size='small' />}
                            label={
                              <Typography
                                sx={{
                                  color: 'var(--Blue-Primary-1, #083A50)',
                                  fontFamily: 'Nunito',
                                  fontSize: '12px !important',
                                  fontStyle: 'normal',
                                  fontWeight: '500',
                                  lineHeight: '20px',
                                }}
                              >
                                By Print Date Invoice
                              </Typography>
                            }
                          />

                          <FormControlLabel
                            sx={{
                              color: 'var(--Blue-Primary-1, #083A50)',
                              fontFamily: 'Nunito',
                              fontSize: '12px !important',
                              fontStyle: 'normal',
                              fontWeight: '400',
                              lineHeight: '20px',
                            }}
                            value='2'
                            control={<Radio size='small' />}
                            label={
                              <Typography
                                sx={{
                                  color: 'var(--Blue-Primary-1, #083A50)',
                                  fontFamily: 'Nunito',
                                  fontSize: '12px !important',
                                  fontStyle: 'normal',
                                  fontWeight: '500',
                                  lineHeight: '20px',
                                }}
                              >
                                By Invoice No. (Job)
                              </Typography>
                            }
                          />

                          <FormControlLabel
                            sx={{
                              color: 'var(--Blue-Primary-1, #083A50)',
                              fontFamily: 'Nunito',
                              fontSize: '12px !important',
                              fontStyle: 'normal',
                              fontWeight: '400',
                              lineHeight: '20px',
                            }}
                            value='3'
                            control={<Radio size='small' />}
                            label={
                              <Typography
                                sx={{
                                  color: 'var(--Blue-Primary-1, #083A50)',
                                  fontFamily: 'Nunito',
                                  fontSize: '12px !important',
                                  fontStyle: 'normal',
                                  fontWeight: '500',
                                  lineHeight: '20px',
                                }}
                              >
                                By General Invoice No. (Non Job)
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      </div>

                      {formik.values.filterBy === '1' && (
                        <Stack direction={'row'} spacing={'32px'} sx={{ marginTop: '12px' }}>
                          <CustomDatePicker
                            name="asPerDate"
                            label="From"
                            value={formik.values.startDate}
                            onChange={(e) => { formik.setFieldValue('startDate', e) }}
                            type={'date'}
                            formControlProps={{
                              sx: {
                                width: '100%',
                              }
                            }}
                          />

                          <CustomDatePicker
                            name="asPerDate"
                            label="To"
                            value={formik.values.endDate}
                            onChange={(e) => { formik.setFieldValue('endDate', e) }}
                            type={'date'}
                            formControlProps={{
                              sx: {
                                width: '100%',
                              }
                            }}
                          />
                        </Stack>
                      )}

                      {['2', '3'].includes(formik.values.filterBy) && (
                        <Stack direction={'row'} spacing={'32px'} sx={{ marginTop: '12px' }}>
                          <Input
                            name="asPerDate"
                            label="From"
                            value={formik.values.startInvoice}
                            onChange={(e) => inputNumberValidation('startInvoice', e)}
                            type={'number'}
                            formControlProps={{
                              sx: {
                                width: '100%',
                              }
                            }}
                          />

                          <Input
                            name="asPerDate"
                            label="To"
                            value={formik.values.endInvoice}
                            onChange={(e) => inputNumberValidation('endInvoice', e)}
                            type={'number'}
                            formControlProps={{
                              sx: {
                                width: '100%',
                              }
                            }}
                          />
                        </Stack>
                      )}
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={6} alignItems={'center'}>
                  <div style={{ height: '100%', alignItems: 'center', display: 'flex' }}>
                    <Typography
                      sx={{
                        color: 'var(--Primary-One, #083A50)',
                        fontFamily: 'Nunito',
                        fontSize: '36px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: '19.6px',
                      }}
                    >
                      Sisa E-NoFa / No. Faktur: {remainingFaktur}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Box>

      {
        isLoading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
          >
            <LoadingSpinner />
          </Backdrop>
        )
      }
    </>
  )
})

export default ExportEFakturView